module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAASBJREFUKFNV0E0vA1EUBuD3bdHSSEQl1iwRFlYSkVYTv8JCd2RmWLCwEawrlVZNSBd+ARW08ZW5MzZ+FDOv3AnFXZ178pycD5bPVU+A+8ihAYBVX9VYGIscntr/z2O5qQVk8YAY62ab0VJd47kcIgpt47LZhzaoXGgmjvGYyWAj2GJgcX4IbyLaocOGNfypKDU0xyy6FKqBx6DSUjEmjIArO0Yf2oJyS7MiOkzgGY9PpRNNMI8uhOt/cNnX9KDQU4L90OPtWk2Fj2HciXjvQ4sGhFcCe8bhzXxNhWIBgRI8hy4PUrhypqlsBgGAXYsWLzUy+plu3jMuD9Nl0nYJjIQd2+4bhQB6ocOj3zu25CfAS+SyY5MlX5sQJkOHx38P/gXHGXysJcCPHwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/common/image1/rxian.png
// module id = rzWr
// module chunks = 28